import { useState, useEffect, useRef } from "react";

import { Typography } from "@mui/material";
import { axiosInstance } from "./../../utility/apiInstance";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Dashboardtable from "../AWBDashboard/Dashboardtable";

import { useRole } from "../MangeContextProvide";
import { useSocket } from "../../context/SocketContext";
import { getDefaultType } from "../../utility/getDefaultSevice";

interface StatusItem {
  count: number;
  status: string;
}

interface StatusData {
  air: StatusItem[];
  ocean: StatusItem[];
}

export default function Dashboard() {
  const [statusData, setStatusData] = useState<StatusData>({
    air: [],
    ocean: [],
  });
  const [error, setError] = useState<string | null>(null);
  const [oceanError, setOceanError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { module, setUnreadCount,role }: any = useRole();
  const socket = useSocket();
  const modules = module || [];

  const [type, setType] = useState(getDefaultType(modules,role));

  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const [isFixed, setIsFixed] = useState(false);
  const [originalOffset, setOriginalOffset] = useState(0);

  useEffect(() => {
    if (scrollContainerRef.current) {
      setOriginalOffset(scrollContainerRef.current.offsetTop);
    }

    const handleScroll = () => {
      if (scrollContainerRef.current) {
        const scrollY = window.scrollY;

        if (scrollY >= originalOffset) {
          setIsFixed(true);
        } else {
          setIsFixed(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [originalOffset]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          setError("No access token found. Please log in.");
          return;
        }

        const endpoint =
          type === "air"
            ? "api/v1/airwaybill/status-wise-awb"
            : "/api/v1/ocean/status-wise";

        const response = await axiosInstance.get(endpoint);
        const data = response.data.data;
        if (type === "air") {
          setStatusData((prev) => ({
            ...prev,
            air: data,
          }));
        } else {
          setStatusData((prev) => ({
            ...prev,
            ocean: data,
          }));
        }
      } catch (error: any) {
        toast.error("Failed to fetch data. Please try again later.");
      }
    };

    fetchData();
  }, [type]);

  useEffect(() => {
    if (!socket) return;

    socket.on("statusWiseCount", (statusWise) => {
      if (type === "air") {
        setStatusData((prev) => ({
          ...prev,
          air: statusWise.air,
        }));
      } else {
        setStatusData((prev) => ({
          ...prev,
          ocean: statusWise.ocean,
        }));
      }
    });
    socket.on("unreadCount", (unreadCount) => {
      setUnreadCount(unreadCount.unRead);
    });

    return () => {
      socket.off("statusWiseCount");
      socket.off("shipementWise");
      socket.off("unreadCount");
    };
  }, [socket]);

 

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  if (oceanError) {
    return <Typography color="error">{oceanError}</Typography>;
  }
  return (
    <>
      <div>
        <Dashboardtable initialFilteredData={[]} />
      </div>
    </>
  );
}
